import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M21.3328 9.91506H17.8368L14.0798 13.6721H12.6008C12.3808 12.1791 11.2448 11.4171 9.20284 11.4171H4.37584L1.96484 13.2751V15.7841L4.98184 13.4171H9.81984C10.2678 13.4171 10.6318 13.7801 10.6318 14.2291C10.6318 14.6781 10.2688 15.0411 9.81984 15.0411H9.20884C9.20884 15.0411 9.20584 15.0411 9.20284 15.0411H6.58384C6.19284 15.4321 5.97484 15.6501 5.58384 16.0411C5.97484 16.4321 6.19284 16.6501 6.58384 17.0411H9.20284C10.9798 17.0411 11.8438 16.3761 12.2628 15.6721H14.9088L18.6658 11.9151H19.5578L18.3168 15.4741L13.4058 19.0001H3.55884L1.96484 20.5951V22.0411H3.34684L4.38784 21.0001H14.0488L19.9948 16.7291L22.1038 10.6851L21.3328 9.91406V9.91506Z" }), jsx("path", { fill: "currentColor", d: "M11.9895 11.012L7.82048 6.84295C6.95548 5.97895 6.74148 4.66295 7.28848 3.56995C7.77248 2.60195 8.74448 2.00195 9.82548 2.00195H10.1295C10.8205 2.00195 11.4735 2.24695 11.9895 2.69695C12.5045 2.24695 13.1585 2.00195 13.8495 2.00195H14.1525C15.2335 2.00195 16.2055 2.60295 16.6895 3.56995C17.2365 4.66395 17.0225 5.97895 16.1575 6.84295L11.9885 11.012H11.9895ZM9.82548 4.00095C9.50648 4.00095 9.22048 4.17895 9.07748 4.46395C8.91648 4.78595 8.97948 5.17395 9.23448 5.42895L11.9895 8.18395L14.7445 5.42895C14.9995 5.17395 15.0625 4.78595 14.9015 4.46395C14.7585 4.17895 14.4725 4.00095 14.1535 4.00095H13.8505C13.6265 4.00095 13.4165 4.08795 13.2595 4.24595L11.9905 5.51495L10.7215 4.24595C10.5655 4.08995 10.3505 4.00095 10.1305 4.00095H9.82648H9.82548Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconHeartOnHand = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconHeartOnHand.displayName = "IconHeartOnHand";

export { IconHeartOnHand };
